import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PETITION_PAGE_CONTACT_DM = defineFcm('petition_page_contact_dm')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			optional: true,
			shape: {
				emailEnabled: { type: 'boolean' },
				phoneEnabled: { type: 'boolean' },
				emailSubjectLine: { type: 'string', optional: true },
				emailBody: { type: 'array', optional: true, shape: { type: 'string' } },
			},
		}),
	)
	.withDefault({
		emailEnabled: false,
		phoneEnabled: false,
		emailSubjectLine: '',
		emailBody: [],
	})
	.toConfig({
		owner: 'squad-capybara',
		scope: 'corgi-front-end',
		context: 'Contact DM CTAs',
		description:
			'Currently English feature, US only. Determines whether to enable certain methods to contact DMs, if contact info is available',
		template: {
			emailEnabled: false,
			phoneEnabled: false,
			emailSubjectLine: 'Subject line here',
			emailBody: ['Dear DM', 'Please respond', 'Best regards'],
		},
	});
